import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button'; 
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { ForgotPasswordComponent } from '../auth/forgot-password/forgot-password.component';
import { LoginComponent } from '../auth/login/login.component';
import { ResetPasswordComponent } from '../auth/reset-password/reset-password.component';
import { SignUpComponent } from '../auth/sign-up/sign-up.component';
import { SignUpEmailComponent } from '../auth/sign-up-email/sign-up-email.component';
import { VerifyEmailComponent } from '../auth/verify-email/verify-email.component';
import { SpinnerServiceComponent } from '../shared/spinner-service/spinner-service.component';



@NgModule({
  declarations: [ForgotPasswordComponent,
    LoginComponent,
    ResetPasswordComponent,
    SignUpComponent,
    SignUpEmailComponent,
    VerifyEmailComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    ButtonModule, 
    PasswordModule,
    InputTextModule,
    ToastModule,
    DividerModule,
    DropdownModule,
    FileUploadModule,
    NgxMaskPipe,
    NgxMaskDirective,
    SpinnerServiceComponent
  ],
  exports: [ForgotPasswordComponent,
    LoginComponent,
    ResetPasswordComponent,
    SignUpComponent,
    SignUpEmailComponent,
    VerifyEmailComponent],

    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AuthModule { }
